import { render, staticRenderFns } from "./ToDoList.vue?vue&type=template&id=50589830&scoped=true&"
import script from "./ToDoList.vue?vue&type=script&lang=ts&"
export * from "./ToDoList.vue?vue&type=script&lang=ts&"
import style0 from "./ToDoList.vue?vue&type=style&index=0&id=50589830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50589830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
